"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CentsOnTheDollarFormula = void 0;
exports.getCentsOnTheDollar = getCentsOnTheDollar;
const general_formulas_1 = require("./general-formulas");
/*
 * Enumeration of CentsOnTheDollar formula implementation names
 */
var CentsOnTheDollarFormula;
(function (CentsOnTheDollarFormula) {
    CentsOnTheDollarFormula[CentsOnTheDollarFormula["DEFAULT"] = 0] = "DEFAULT";
})(CentsOnTheDollarFormula || (exports.CentsOnTheDollarFormula = CentsOnTheDollarFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getCentsOnTheDollar(formula) {
    switch (formula) {
        default:
            return default_centsOnTheDollar;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_centsOnTheDollar = (paybackAmount, drawAmount) => {
    // ensure valid argument types
    if (typeof paybackAmount === 'number' && typeof drawAmount === 'number') {
        return (0, general_formulas_1.toFixedNumber)(paybackAmount / drawAmount, 2);
    }
    return NaN;
};
//# sourceMappingURL=cents-on-the-dollar-formula.js.map